import { useLayoutContent } from "./useLayout";

export const useHomeLayout = () => {
  return useLayoutContent<{
    categories: any[];
    persons: any[];
    projects: any[];
    items: any[];
  }>({
    resource: "content",
    query: { route: "home", platform: 1 },
    selectors: {
      categories: { module: "categories" },
      persons: { module: "list", alias: "persons" },
      projects: { module: "list", alias: "projects" },
      items: { module: "list", alias: "items" },
    },
    normalizers: {
      persons: (data: any[]) =>
        data.map((item) => ({
          id: item.id,
          name: item.name ?? "",
          nickname: item.dyna?.nickname ?? "",
          layout: item.dyna?.position ?? item.layout ?? "",
          introduction: item.dyna?.introduction ?? item.introduction ?? "",
          works: item.dyna?.work ?? "",
          logo: item?.dyna?.cover ?? item?.dyna?.logo ?? item?.logo ?? "",
          created_at: item.created_at,
        })),
      projects: (data: any[]) =>
        data.map((item) => ({
          id: item.id,
          name: item.name ?? "",
          meta_text: item.dyna?.meta_text ?? item.meta_text ?? "",
          logo: item?.dyna?.cover ?? item?.dyna?.logo ?? item?.logo ?? "",
          categories: item.dyna?.categories ?? item.categories ?? [],
          date_establishment: item.dyna?.date_establishment ?? null,
          created_at: item.created_at,
        })),
    },
  });
};
